export default class Values {
  constructor(node, index) {
    this.node = node

    this.gridContainer = this.node.parentNode

    this.allItems = this.gridContainer.querySelectorAll('.values-grid-element')
    this.button = this.node.querySelector('.icon--accordion')

    this.hoverAction = this.hoverAction.bind(this)
    this.clickAction = this.clickAction.bind(this)

    this.init()
  }

  init() {
    this.addListeners()
  }

  addListeners() {
    this.button.addEventListener('click', this.clickAction)
    this.node.addEventListener('mouseover', this.hoverAction)
  }

  clickAction(e) {
    this.allItems.forEach((item) => {
      if (this.node != item) {
        const button = item.querySelector('.icon--accordion')
        item.classList.remove('open')
        button.classList.remove('icon--transform-minus')
      }
    })
    this.node.classList.toggle('open')
    this.button.classList.toggle('icon--transform-minus')
  }

  hoverAction(e) {
    this.node.classList.remove('first-load')
  }

  reset() {
    this.node.classList.remove('open')
    this.button.classList.remove('icon--transform-minus')
  }

  destroy() {
    this.button.removeEventListener('click', this.clickAction)
    this.reset()
  }

  static resetAll() {
    setTimeout(() => {
      Values.items.forEach((elem) => {
        elem.reset()
      })
    }, 500)
  }

  static destroyAll() {
    Values.items.forEach((elem) => {
      elem.destroy()
    })
  }

  static init() {
    Values.items = Array.from(
      document.querySelectorAll('.values-grid-element')
    ).map((node, index) => new Values(node, index))
  }
}
